import React, { useEffect } from "react"

export function MyHoldings() {
  return <p>我的持仓面板</p>
}
